<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13.077"
    viewBox="0 0 13 13.077"
  >
    <path
      d="M7.1,6.136l4.673-4.673a.777.777,0,1,0-1.1-1.1L6,5.036,1.327.364a.777.777,0,0,0-1.1,1.1L4.9,6.136.228,10.808a.777.777,0,1,0,1.1,1.1L6,7.235l4.673,4.673a.777.777,0,0,0,1.1-1.1Zm0,0"
      transform="translate(0.5 0.441)"
      stroke-width="1"
    />
  </svg>
</template>

<script>
export default {
  name: "reject-icon",
};
</script>
